import { Option } from "src/app/shared/models/option.interface";

export const AGE_OPERATORS: Option[] = [
    {
        key: '>',
        name: 'More Then',
    },
    {
        key: '>=',
        name: 'More, or equal',
    },
    {
        key: '<',
        name: 'Less Then',
    },
    {
        key: '<=',
        name: 'Less, or equal',
    },
    {
        key: '=',
        name: 'Equal',
    },
];